/******************
* Sharing Sidebar
*******************/
if(typeof FN == 'undefined') FN = {};


FN.sharingBar = {
  config: {
    containerCssSelector: false,
    topThresholdCssSelector: false
  },
  visible: false,  
  topThreshold: 0,

  init: function(config){
    FN.sharingBar.config = config;
    if(!document.querySelector(FN.sharingBar.config.containerCssSelector)) return;
    
    FN.sharingBar.resetTopThreshold();
    
    window.addEventListener('resize', function(){
      FN.sharingBar.resetTopThreshold();
    });

    window.addEventListener('scroll', function() {
      var scrollingPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
      FN.sharingBar.toggle(scrollingPosition > FN.sharingBar.topThreshold);
    });
  },
  
  toggle: function(show){
    if(show === FN.sharingBar.visible){ return; }
    var newFloatingSidebarPos = (show) ? '-6px' : '-70px';
    document.querySelectorAll(FN.sharingBar.config.containerCssSelector).forEach(function(el) {
      el.style.right = newFloatingSidebarPos;
    });
    FN.sharingBar.visible = show;
  },
  
  resetTopThreshold: function(){
    var topThresholdElement = document.querySelector(FN.sharingBar.config.topThresholdCssSelector);
    if(!topThresholdElement) return;
    
    FN.sharingBar.topThreshold = topThresholdElement.getBoundingClientRect().top + window.pageYOffset;
  }
};
